import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import './MenuGroupCarouselItem.css'

export const MenuGroupCarouselItem = ({
  item,
  activeItemId
}) => {
  const {id, href, title, name} = item
  return (
    <div
      key={id}
      data-navid={id}
      className='menu-nav-item'
      data-testid='menu-nav-item'
      styleName='navItem'
    >
      <a
        href={href}
        title={title}
        styleName={cx('linkNav link', {active: activeItemId === id})}
      >
        {name}
      </a>
    </div>
  )
}

MenuGroupCarouselItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    href: PropTypes.string,
    title: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  activeItemId: PropTypes.string
}
